import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../../Containers/Config/index.js';
import { GET_FAB_SURGE_FILTER, GET_FAB_SURGE_FILTER_SUCCESS, GET_FAB_SURGE_FILTER_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getLedgerFilter({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/filters`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_FAB_SURGE_FILTER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_FAB_SURGE_FILTER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_FAB_SURGE_FILTER_ERROR, payload: error });
  }
}

export function* watchgetLedgerFilter() {
  yield takeEvery(GET_FAB_SURGE_FILTER, getLedgerFilter);
}

function* getLedgerFilterSaga() {
  yield all([fork(watchgetLedgerFilter)]);
}

export default getLedgerFilterSaga;
